import React from 'react';
import { CheckCircle } from 'lucide-react';

const ReviewStep = ({ formData, venues, ticketTypes, errors }) => {
  const venueName = venues.find((v) => v.id === formData.venueId)?.name || 'Selected Venue';

  return (
    <div className="form-section">
      <h3><CheckCircle size={24} /> Review & Submit</h3>
      <p>Everything looks perfect! Review your event details before launching.</p>

      {errors.submit && <div className="error-message">{errors.submit}</div>}

      <div className="summary-panel">
        <h4 className="summary-title">🎭 Event Summary</h4>

        <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div>
            <p><strong>🎪 Title:</strong> {formData.title}</p>
            <p><strong>🏷️ Category:</strong> {formData.category}</p>
            <p><strong>🎯 Type:</strong> {formData.eventType}</p>
            <p><strong>🏛️ Venue:</strong> {venueName}</p>
            <p><strong>💺 Seating:</strong> {formData.seatingMode}</p>
          </div>
          <div>
            <p><strong>📅 Starts:</strong> {new Date(formData.eventDate).toLocaleDateString()} {formData.eventTime}</p>
            <p><strong>📅 Ends:</strong> {new Date(formData.endDate).toLocaleDateString()} {formData.endTime}</p>
            <p><strong>🎫 Ticket Types:</strong> {ticketTypes.length}</p>
            <p><strong>⭐ Featured:</strong> {formData.isFeatured ? '✅ Yes' : '❌ No'}</p>
          </div>
        </div>

        {ticketTypes.length > 0 && (
          <div className="summary-block">
            <h5 className="summary-title" style={{ fontSize: '1.1rem', marginTop: '0' }}>🎫 Ticket Pricing</h5>
            <div className="pricing-list">
              {ticketTypes.map((ticket) => (
                <div key={ticket.id} className="ticket-pricing-chip">
                  <strong>{ticket.name}</strong>
                  <br />
                  ${ticket.priceAmount} {ticket.currencyCode}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewStep;
